import Form from 'scripts/components/base/Form'

export default {
  init() {
    const components = {
      form: new Form('#form')
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js